import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { BusinessCustomerDto } from '@/api/generated';
import { useCustomerUpdateMutationOptions } from '@/views/customers/status/useCustomerMutationOptions.util.ts';

type Req = {
  customerId: number;
  data: BusinessCustomerDto;
};

type Return = {
  isUpdatingBusinessCustomer: boolean;
  updateBusinessCustomer: (req: Req) => Promise<void>;
};

export const useUpdateBusinessCustomer = (): Return => {
  const { customersApi } = useApiClient();
  const updateOptions = useCustomerUpdateMutationOptions();

  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    ...updateOptions,
    mutationFn: async req => {
      const res = await customersApi.updateBusinessCustomer(req.customerId, req.data);

      return res.data;
    },
  });

  return {
    isUpdatingBusinessCustomer: isPending,
    updateBusinessCustomer: mutateAsync,
  };
};
